import React, { Component } from 'react'
import { Redirect } from "react-router-dom";
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Formik } from 'formik'
import * as Yup from 'yup';
import { Loading } from './Loading'
import Auth from '../../Auth'
import LoginImg from '../../images/login_poster.png'
import { setGrayBody } from './BodyBg'
import Source from '../../Source'
const source = new Source();
const auth = new Auth();

export class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isDialogOpen: false,
            message: '',
            success: true,
            showLoading: false,
            smsCountDown: 0,
            redirectToReferrer: false,
            title: '提示'
        }
    }

    handleDialogOk = () => {
        console.log("ok")

        if (this.state.success) {
            this.setState({ isDialogOpen: false, success: true, message: '', redirectToReferrer: true })
        }
        else {
            this.setState({ isDialogOpen: false, success: true, message: '' })
        }
    }

    handleCaptchaClick = (e) => {
        e.target.src = "/Captcha/GetRegisterCaptcha?timestamp=" + new Date().getTime();
    }

    handleSmsButtonClick = (phoneNumber, imageCode) => {
        const postApi = '/api/Account/GetSmsCode';
        const apiPara = { imageCode: imageCode, phoneNumber: phoneNumber };

        if (this.state.smsCountDown === 0) {
            if (!apiPara.phoneNumber) {
                this.setState({ isDialogOpen: true, success: false, message: '请输入手机号！' });
                return;
            }

            this.setState({ smsCountDown: 120 }, () => {
                this.timer = setInterval(() => {
                    if (this.state.smsCountDown > 0) {
                        this.setState({ smsCountDown: this.state.smsCountDown - 1 })
                    } else {
                        clearInterval(this.timer);
                    }
                }, 1000)
            });

            fetch(postApi, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'same-origin',
                body: JSON.stringify(apiPara)
            }).then(Response => Response.json())
                .then(
                    json => {
                        console.log(json);
                        if (json.Success) {
                            this.setState({ isDialogOpen: true, success: false, message: json.Message })
                        } else {
                            this.setState({ isDialogOpen: true, success: false, message: json.Message, smsCountDown: 0 });
                        }
                    }

                ).catch(error => {
                    console.error(error);
                    this.setState({ isDialogOpen: true, success: false, message: '短信发送失败！', smsCountDown: 0 });
                })
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer)
    }

    componentDidMount() {
        setGrayBody();
    }

    render() {
        const { from } = this.props.location.state || { from: { pathname: "/" } };
        const { redirectToReferrer } = this.state;

        if (redirectToReferrer) {
            return <Redirect to={from} />;
        }

        return (
            <div>
                <Formik
                    initialValues={{
                        phoneNumber: '',
                        imageCode: '',
                        smsCode: ''
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        this.setState({ showLoading: true });

                        setTimeout(() => {
                            console.log(values)

                            var data = new FormData();
                            data.append('phoneNumber', values.phoneNumber);
                            data.append('smsCode', values.smsCode);

                            console.log(data);

                            let sourceValue = source.getSource() === undefined ? "" : source.getSource().code;
                            //提交数据
                            fetch('/api/account/login', {
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                method: 'POST',
                                credentials: 'same-origin',
                                body: JSON.stringify({ phoneNumber: values.phoneNumber, smsCode: values.smsCode, source: sourceValue })
                            })
                                .then(Response => Response.json()).then(
                                    json => {
                                        console.log(json)

                                        this.setState({ showLoading: false });
                                        //提示
                                        this.setState({ isDialogOpen: true, success: json.Success, message: json.Message });
                                    }

                                )
                                .catch(error => {
                                    console.error(error);
                                    this.setState({ showLoading: false });
                                })

                            //恢复提交按钮状态
                            setSubmitting(false);
                        }, 500);
                    }}
                    validationSchema={Yup.object().shape({
                        phoneNumber: Yup.string().required('必填'),
                        smsCode: Yup.string().required('必填')
                    })}
                >
                    {props => {
                        const {
                            values,
                            touched,
                            errors,
                            isSubmitting,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                        } = props;
                        return (
                            <div className="account-page clearfix">
                                <div className="account float-left">
                                    <div className="account-title">
                                        <div>Hi</div>
                                        <div><span>欢迎登录</span></div>
                                    </div>
                                    <div className="account-form">
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-item">
                                                <input
                                                    id="phoneNumber"
                                                    placeholder="建议使用常用手机号"
                                                    type="text"
                                                    value={values.phoneNumber}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    className={
                                                        errors.phoneNumber && touched.phoneNumber ? 'text-input error' : 'text-input'
                                                    }
                                                />
                                                {errors.phoneNumber &&
                                                    touched.phoneNumber && <div className="web-input-feedback">{errors.phoneNumber}</div>}
                                            </div>
                                            <div className="form-item clearfix">
                                                <input placeholder="不区分大小写"
                                                    id="imageCode"
                                                    type="text" value={values.imageCode}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    className={errors.imageCode && touched.imageCode ? 'text-input error web' : 'text-input web'} />
                                                <img className="float-right" alt="图片验证码" src="/Captcha/GetRegisterCaptcha?t=@Guid.NewGuid()" onClick={this.handleCaptchaClick.bind(this)} />
                                            </div>
                                            <div className="form-item clearfix">
                                                <input
                                                    id="smsCode"
                                                    placeholder="请输入短信验证码"
                                                    type="text"
                                                    value={values.smsCode}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    className={
                                                        errors.smsCode && touched.smsCode ? 'text-input error web' : 'text-input web'
                                                    }
                                                />
                                                <a className={this.state.smsCountDown === 0 ? 'enable' : 'disable'}
                                                    onClick={this.handleSmsButtonClick.bind(this, values.phoneNumber, values.imageCode)}>
                                                    {this.state.smsCountDown === 0 ? "获取验证码" : '重新获取'}{this.state.smsCountDown === 0 ? '' : '(' + this.state.smsCountDown + ')'}
                                                </a>
                                                {errors.smsCode && touched.smsCode && <div className="web-input-feedback">{errors.smsCode}</div>}
                                            </div>
                                            <div className="account-btn">
                                                <button name="button" type="submit" value="login" disabled={isSubmitting}>登录</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="poster">
                                    <img className="login-poster" src={LoginImg} alt="登录" />
                                </div>
                            </div>

                        );
                    }}
                </Formik>

                {this.state.isDialogOpen && <Dialog title={this.state.title} style={{ width: "300px;" }} closeIcon={false}>
                    <p style={{ margin: "10px", width: "200px" }}>{this.state.message}</p>
                    <DialogActionsBar>
                        <button className="k-button" onClick={this.handleDialogOk}>确定</button>
                    </DialogActionsBar>
                </Dialog>}
                <Loading isLoading={this.state.showLoading} />
            </div>
        );
    }
}

export default Login